import React, { useState } from 'react';
import { auth, db } from './firebase';
import { createUserWithEmailAndPassword, signInWithEmailAndPassword } from 'firebase/auth';
import { doc, setDoc, serverTimestamp } from 'firebase/firestore';
import './App.css'; // CSS ဖိုင်ကို Import လုပ်ထားဖို့ မမေ့ပါနဲ့

const Auth = () => {
    const [isActive, setIsActive] = useState(false);
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [name, setName] = useState('');
    const [message, setMessage] = useState({ text: '', type: '' });

    const showNotice = (text, type) => {
        setMessage({ text, type });
        setTimeout(() => setMessage({ text: '', type: '' }), 4000);
    };

    const handleSignUp = async (e) => {
        e.preventDefault();
        try {
            const res = await createUserWithEmailAndPassword(auth, email, password);
            await setDoc(doc(db, "users", res.user.uid), {
                name: name,
                email: email,
                points: 0,
                memberType: 'Free',
                createdAt: serverTimestamp()
            });
            showNotice('အကောင့်ဖွင့်ခြင်း အောင်မြင်ပါသည်!', 'success');
        } catch (error) {
            showNotice('မအောင်မြင်ပါ- ' + error.message, 'error');
        }
    };

    const handleLogin = async (e) => {
        e.preventDefault();
        try {
            await signInWithEmailAndPassword(auth, email, password);
            showNotice('Login ဝင်ခြင်း အောင်မြင်ပါသည်!', 'success');
        } catch (error) {
            showNotice('Login မအောင်မြင်ပါ- Email သို့မဟုတ် Password မှားနေသည်!', 'error');
        }
    };

    return (
        <div className="auth-v2-body">
            <div className={`auth-v2-container ${isActive ? "active" : ""}`}>
                
                {/* --- Sign Up Form --- */}
                <div className="form-container sign-up">
                    <form onSubmit={handleSignUp}>
                        <h2 className="gold-brand">BABYLON APP</h2>
                        
                        {message.text && (
                            <div className={`status-msg ${message.type === 'success' ? 'msg-success' : 'msg-error'}`}>
                                {message.text}
                            </div>
                        )}

                        <p className="sub-txt">CREATE YOUR ACCOUNT</p>
                        <input type="text" placeholder="Full Name" className="input-box" value={name} onChange={(e) => setName(e.target.value)} required />
                        <input type="email" placeholder="Email Address" className="input-box" value={email} onChange={(e) => setEmail(e.target.value)} required />
                        <input type="password" placeholder="Password" className="input-box" value={password} onChange={(e) => setPassword(e.target.value)} required />
                        <button type="submit" className="main-btn">SIGN UP</button>
                    </form>
                </div>

                {/* --- Sign In Form --- */}
                <div className="form-container sign-in">
                    <form onSubmit={handleLogin}>
                        <h2 className="gold-brand">BABYLON APP</h2>

                        {message.text && (
                            <div className={`status-msg ${message.type === 'success' ? 'msg-success' : 'msg-error'}`}>
                                {message.text}
                            </div>
                        )}

                        <p className="sub-txt">ENTER YOUR CREDENTIALS</p>
                        <input type="email" placeholder="Email Address" className="input-box" value={email} onChange={(e) => setEmail(e.target.value)} required />
                        <input type="password" placeholder="Password" className="input-box" value={password} onChange={(e) => setPassword(e.target.value)} required />
                        
                        <button type="button" className="forget-link">Forgot Your Password?</button>
                        <button type="submit" className="main-btn">SIGN IN</button>
                    </form>
                </div>

                {/* --- Slider Panels --- */}
                <div className="toggle-container">
                    <div className="toggle">
                        <div className="toggle-panel toggle-left">
                            <h1>Welcome Back!</h1>
                            <p>Already a member? Sign in to continue your earning journey.</p>
                            <button className="ghost-btn" onClick={() => setIsActive(false)}>SIGN IN</button>
                        </div>
                        <div className="toggle-panel toggle-right">
                            <h1>Hello, Friend!</h1>
                            <p>Register with your personal details to use all of site features.</p>
                            <button className="ghost-btn" onClick={() => setIsActive(true)}>SIGN UP</button>
                        </div>
                    </div>
                </div>

            </div>
        </div>
    );
};

export default Auth;